import store from '../../store';
import { isDefined } from '../utils/utils';
import { SET_SELECTED_PAGE } from '../../store/mutations/page.mutations';

export const PageExistsGuard = (to, from, next) => {
  const pageParam = to.params['page'];

  const page = store.getters.getPageBySlug(pageParam);

  if (isDefined(page)) {
    store.commit(SET_SELECTED_PAGE, page);
    return next();
  }

  return next({name: '404'});
};